export default __webpack_public_path__ + "four-black-squares.png";